import ActionTypes from '@ziynx/action-types';
import type { ChannelType } from '@ziynx/flow-types/channel';

type GetChannelResponse = {
  title: string,
  data: Array<ChannelType>,
}

type ChannelAction = {
  id: string,
  type: string,
  response?: GetChannelResponse,
  error?: any,
  userInfo?: {
    channelId: string,
    _id: string,
  },
}

const initialState = {};

const getNewChannelArray = (talentId, channelState, option) => {
  const channelResults = (channelState?.results ?? []).map((talent) => {
    if (talent?.profile?._id !== talentId) return talent;
    return {
      ...talent,
      profile: {
        ...talent?.profile ?? {},
        isWatched: option !== 'remove',
      },
    };
  });
  return channelResults || [];
};

export default function reduceChannel(state = initialState, action: ChannelAction) {
  if (!action.type) {
    return state;
  }

  const channelState = state[action?.id] ?? {};

  switch (action?.type) {
  case ActionTypes.discover.getChannel.START:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...channelState,
          fetching: true,
          success: false,
          error: null,
        },
      },
    };
  case ActionTypes.discover.getChannel.SUCCESS:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...channelState,
          ...(action?.response ?? {}),
          results:
            action?.isFirstPage
              ? action?.response?.results
              : (channelState?.results || []).concat(action?.response?.results ?? []),
          fetching: false,
          success: true,
          error: null,
        },
      },
    };

  case ActionTypes.watchlist.add.START:
  case ActionTypes.watchlist.remove.ERROR:
    return {
      ...state,
      ...{
        [action?.userInfo?.channelId]: {
          ...state[action?.userInfo?.channelId] || {},
          results: getNewChannelArray(action?.userInfo?._id, state[action?.userInfo?.channelId], 'add'),
        },
      },
    };

  case ActionTypes.watchlist.remove.START:
  case ActionTypes.watchlist.add.ERROR:
    return {
      ...state,
      ...{
        [action?.userInfo?.channelId]: {
          ...state[action?.userInfo?.channelId] || {},
          results: getNewChannelArray(action?.userInfo?._id, state[action?.userInfo?.channelId], 'remove'),
        },
      },
    };
  case ActionTypes.discover.getChannel.ERROR:
    return {
      ...state,
      ...{
        [action?.id]: {
          ...channelState,
          fetching: false,
          success: false,
          error: action?.error,
        },
      },

    };
  case ActionTypes.watchlist.add.SUCCESS:
  case ActionTypes.watchlist.remove.SUCCESS:
  default:
    return state;
  }
}
